/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, June 3rd 2022, 1:29:22 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Button from "@mui/material/Button";
import Skeleton from "@mui/material/Skeleton";
import { Image } from "ui-widgets";

interface OSCardProps extends Pick<React.HTMLAttributes<HTMLDivElement>, "onClick"> {
  cardTitle: React.ReactNode;
  imageURL?: string;
  actionText?: React.ReactNode;
  variant?: "filled" | "grid";
}

export const OSCard = ({ onClick, cardTitle, actionText, imageURL, variant = "filled" }: OSCardProps) => {
  let cardComponent: React.ReactNode;
  switch (variant) {
    case "grid":
      cardComponent = (
        <div className="os-service-card grid d-flex" onClick={onClick}>
          <figure className="os-service-image">
            <Image className="image-style-A" src={imageURL ?? "/img/no-image.png"} alt="Onestop Admin" />
          </figure>
          <div className="os-service-content">
            <h4>{cardTitle}</h4>
            {actionText ? (
              <div className="os-service-content-cta">
                <Button variant="outlined">{actionText}</Button>
              </div>
            ) : null}
          </div>
        </div>
      );
      break;

    case "filled":
      cardComponent = (
        <div className="os-service-card filled" onClick={onClick}>
          <div className="os-service-content">
            <h4>{cardTitle}</h4>
            {actionText ? (
              <div className="os-service-content-cta">
                <Button variant="contained" className="os-cta-edit-services">
                  {actionText}
                </Button>
              </div>
            ) : null}
          </div>
          <figure className="os-service-image-2">
            <Image className="image-style-B" src={imageURL ?? "/img/no-image.png"} alt="Onestop Admin" />
          </figure>
        </div>
      );
      break;
  }

  return <>{cardComponent}</>;
};

export const OSCardSkeleton = () => (
  <div className="os-service-card d-flex">
    <figure className="os-service-image">
      <Skeleton component="div" width="100%" height="100%" sx={{ transform: "scale(1,1)" }} />
    </figure>
    <div className="os-service-content">
      <Skeleton component="h4" width={140} height={23} />
      <div className="os-service-content-cta">
        <Skeleton component="button" width={64} height={28} sx={{ transform: "scale(1,1)" }} />
      </div>
    </div>
  </div>
);
